import { IArrayOption } from '../../../model/IArrayOption';
import { IFlyingHours } from '../../../model/IFlyingHours';
import { IFilter } from '../../../model/search/IFilter';
import { IPagination } from '../../../model/search/IPagination';
import { ISearch } from '../../../model/search/ISearch';
import { FlyingDetailCRUD } from '../../../operations/FlyingDetailCRUD';
import { bindCostCenterDropdown } from '../../../services/1GXCoding/CostCenterService';
import { bindInternalOrderDropdown } from '../../../services/1GXCoding/InternalOrderService';
import { CostingActivityService } from '../../../services/domainServices/CostingActivityService';
import { CrewTypeService } from '../../../services/domainServices/CrewTypeService';
import { FireNumberService } from '../../../services/domainServices/FireNumberService';
import { RateTypeService } from '../../../services/domainServices/RateTypeService';
import { RateUnitService } from '../../../services/domainServices/RateUnitService';
import { FlyingHoursService } from '../../../services/flyingHours/FlyingHoursService';

async function getCrewTypeByID(crewTypeId: string) {
  try {
    var response: any = await CrewTypeService.getById(crewTypeId);
    return response.data;
  } catch (Error) {
    console.log('Error', Error);
  }
}

async function getCostingActivityByID(id: string) {
  try {
    var response: any = await CostingActivityService.getById(id);
    return response.data;
  } catch (Error) {
    console.log('Error', Error);
  }
}

async function getRateTypeByID(id: string) {
  try {
    var response: any = await RateTypeService.getById(id);
    return response.data;
  } catch (Error) {
    console.log('Error', Error);
  }
}

async function getRateUnitByID(rateUnitId: string) {
  try {
    var response: any = await RateUnitService.getById(rateUnitId);
    return response.data;
  } catch (Error) {
    console.log('Error', Error);
  }
}

async function getFireNumberByID(fireNumberId: string, strToken: string = '') {
  try {
    var response: any = await FireNumberService.getById(fireNumberId, strToken);
    if (response.status) return response.data.data;
  } catch (Error) {
    console.log('Error', Error);
  }
}

export const getFlyingHours = async (
  flightReportId: number,
  token: string,
  fireNumberOptions: IArrayOption[],
  crewTypeOptions: IArrayOption[],
  costingActivityOptions: IArrayOption[],
  rateTypeOptions: IArrayOption[],
  rateUnitOptions: IArrayOption[],
  internalOrderOptions: IArrayOption[],
  costCenterOptions: IArrayOption[],
  fundOptions: IArrayOption[],
  accountOptions: IArrayOption[],
): Promise<IFlyingHours[]> => {
  let objIPagination: IPagination = {
    perPage: 20,
    page: 1,
  };

  let objIFilter: IFilter = {
    columnName: 'expenseType',
    columnValue: 'FlyingHours',
  };

  let objISearch: ISearch = {
    search: '',
    sortBy: '',
    sortOrder: '',
    filterBy: objIFilter,
    pagination: objIPagination,
  };

  const response = await FlyingHoursService.getSearch(objISearch, flightReportId, token);

  const updatedData = await Promise.all(
    (response.data.data ?? []).map(async (record: IFlyingHours) => {
      let updatedRecord = { ...record };

      if (record.fireNumberId) {
        const fireNumber = await getFireNumberByID(record.fireNumberId, token);
        updatedRecord.fireNumberEntity = fireNumber ?? undefined;
        updatedRecord.fireNumber = fireNumber?.fireNumber;
      }

      if (record.crewTypeId) {
        const crewType = await getCrewTypeByID(record.crewTypeId);
        updatedRecord.crewTypeEntity = crewType ?? undefined;
      }

      if (record.costingActivityId) {
        const costingActivity = await getCostingActivityByID(record.costingActivityId);
        updatedRecord.costingActivityEntity = costingActivity ?? undefined;
        updatedRecord.costingActivityCode = costingActivity?.code;
      }

      if (record.rateTypeId) {
        const rateType = await getRateTypeByID(record.rateTypeId);
        updatedRecord.rateTypeEntity = rateType ?? undefined;
      }

      if (record.rateUnitId) {
        const rateUnit = await getRateUnitByID(record.rateUnitId);
        updatedRecord.rateUnitEntity = rateUnit ?? undefined;
      }

      // dropdowns
      updatedRecord.fireNumberList = fireNumberOptions ?? undefined;
      updatedRecord.crewTypeList = crewTypeOptions ?? undefined;
      updatedRecord.costingActivityList = costingActivityOptions ?? undefined;
      updatedRecord.rateTypeList = rateTypeOptions ?? undefined;
      updatedRecord.rateUnitList = rateUnitOptions ?? undefined;

      // internal order
      if (!record.internalOrder || internalOrderOptions.find((x) => x.value === record.internalOrder)) {
        updatedRecord.internalOrderList = internalOrderOptions ?? undefined;
      } else {
        const res = await FlyingDetailCRUD.getInternalOrder(record.internalOrder, token);
        if (res.data) {
          updatedRecord.internalOrderList = bindInternalOrderDropdown(res.data);
        }
      }

      // cost center
      if (!record.costCenter || costCenterOptions.find((x) => x.value === record.costCenter)) {
        updatedRecord.costCenterList = costCenterOptions ?? undefined;
      } else {
        const res = await FlyingDetailCRUD.getCostCenter(record.costCenter, token);
        if (res.data) {
          updatedRecord.costCenterList = bindCostCenterDropdown(res.data);
        }
      }

      updatedRecord.fundList = fundOptions ?? undefined;
      updatedRecord.accountList = accountOptions ?? undefined;

      return updatedRecord;
    }),
  );

  return updatedData;
};
